import { media } from './../models/media.model';
import { MediaService } from './media.service';
import { Player } from '../models/player.model';
import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { Platform } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()

export class PlayerService {

  playList: media[] = [];
  playListIndex: number;

  isPlaying: boolean = false;
  isPlayingUpdatable: boolean = true;
  isPlayingDuration: number;
  isPlayingDurationStr: string;
  isPlayingCurrentTime: number;
  isPlayingCurrentTimeStr: string;

  isPlayingProcent: number;
  nowPlaying: Player = new Player();
  audio = new Audio();

  constructor(private mService: MediaService, private us: UserService, public plt: Platform, private sanitizer: DomSanitizer){
    this.nowPlaying.continous = 0;
  }


  load(id:number, play:boolean)
  {

    this.mService.load(id).then((item: media) => {

      let found = false;
      this.playListIndex = 0;
      this.playList.forEach(element => {
        if (!found)
        {
          this.playListIndex++;
        }
        if (element.id == item.id)
        {
          this.playListIndex--;
          element.playing = true;
          found = true;
        }
        else
        {
          element.playing = false;
        }
      });

      if (!found)
      {
        item.playing = true;
        this.playList.push(item);
      }

      if (this.us.user.quality == "")
      {
        this.us.user.quality = "high";
      }

      this.nowPlaying.id = item.id;
      this.nowPlaying.title = item.title;
      this.nowPlaying.album = item.album.title;
      this.nowPlaying.albumid = item.album.id;
      this.nowPlaying.artist = item.album.artist_string;
      this.nowPlaying.mediaType = item.type;

      if (item.type == "audio")
      {
        if (this.plt.is('cordova'))
        {
          this.nowPlaying.mediaUrl = item.path + this.us.user.quality + ".m4a"; //+ ".oga";
        }
        else
        {
          this.nowPlaying.mediaUrl = item.path + this.us.user.quality + ".mp3";
        }
      }
      else
      {
        this.nowPlaying.secureMediaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(item.path);
      }
      this.nowPlaying.graphic = item.album.cover_url;

      if (play)
      {
        if (this.isPlaying)
        {
          this.pause();
        }
        this.play();
      }

    });


  }

  playId(id:number)
  {
    this.load(id, true);
  }

  play() {
    if (this.nowPlaying.id != 0)
    {
      this.audio.src = this.nowPlaying.mediaUrl;

      if (this.nowPlaying.mediaType == "audio")
      {
        setTimeout(() => {
          this.audio.play();
        }, 0);
      }
      else
      {


      }


      this.isPlaying = true;
      this.isPlayingDuration = Math.round(this.audio.duration);
      this.isPlayingDurationStr = this.formatSeconds(this.audio.duration);
      this.audio.ontimeupdate = () => {
        if (this.isPlayingUpdatable)
        {
          this.isPlayingCurrentTime = Math.round(this.audio.currentTime);
          this.isPlayingCurrentTimeStr = this.formatSeconds(this.audio.currentTime);
          this.isPlayingDuration = this.audio.duration;
          this.isPlayingDurationStr = this.formatSeconds(this.audio.duration);
          this.isPlayingProcent = Math.round((this.isPlayingCurrentTime / this.isPlayingDuration) * 100);

          if (this.audio.currentTime == this.audio.duration)
          {
            let next = 0;
            let first = 0;
            let found = false;
            this.playList.forEach(element => {

              if (first == 0)
              {
                first = element.id;
              }

              if (found)
              {
                next = element.id;
                found = false;
              }

              if (element.id == this.nowPlaying.id)
              {
                found = true;
              }
            });

            if (next && this.nowPlaying.continous == 0)
            {
                this.load(next, true);
            }
            else if (next == 0 && this.nowPlaying.continous == 1)
            {
                this.load(first, true);
            }
            else if (this.nowPlaying.continous == 2)
            {
              this.load(this.nowPlaying.id, true);
            }
            else
            {
              this.isPlaying = false;
            }



          }

        }
        else
        {
          this.isPlayingCurrentTimeStr = this.formatSeconds(this.audio.currentTime);
        }
      }
    }
  }

  rewind()
  {
    if (this.audio.currentTime < 4)
    {
        if (this.playListIndex > 0)
        {
          this.load(this.playList[this.playListIndex - 1].id, true);
        }
    }
    else
    {
      this.audio.currentTime = 0;
    }
  }

  next()
  {
    if (this.playListIndex < this.playList.length - 1)
    {
      this.load(this.playList[this.playListIndex + 1].id, true);
    }
  }

  pause(){
    if (this.nowPlaying.mediaType == "audio")
    {
      this.audio.pause();
    }
    else
    {

    }
    this.isPlaying = false;
  };

  continous(value: number)
  {
    this.nowPlaying.continous = value;
  }

  seek(seconds)
  {
    if (this.isPlaying == false)
    {
      this.play();
    }
    this.audio.currentTime = seconds;
  }

  formatSeconds(seconds){
    var minutes = Math.floor(seconds / 60);
    seconds = seconds - minutes * 60;
    if (Math.round(seconds) > 9 )
    {
      return minutes + ":" + Math.round(seconds);
    }
    else
    {
      return minutes + ":0" + Math.round(seconds);
    }
  }

}



// WEBPACK FOOTER //
// ./src/service/player.service.ts